export interface ImpersonationTarget {
  id?: number | string;
  dni?: string;
  firstname?: string;
  lastname?: string;
}

export interface ImpersonationPayload {
  userId?: number | string;
  dni?: string;
}

export function buildImpersonationPayload(
  target?: ImpersonationTarget | null,
): ImpersonationPayload | null {
  if (!target) {
    return null;
  }

  if (target.dni) {
    return { dni: target.dni };
  }

  if (target.id) {
    return { userId: target.id };
  }

  return null;
}

export function buildImpersonationLabel(
  target?: ImpersonationTarget | null,
): string {
  if (!target) {
    return '';
  }

  const name = [target.firstname, target.lastname].filter(Boolean).join(' ');

  if (name) {
    return name;
  }

  if (target.dni) {
    return target.dni;
  }

  if (target.id) {
    return String(target.id);
  }

  return '';
}

export function getImpersonationErrorMessage(
  error: unknown,
  fallback: string,
): string {
  const typedError = error as {
    response?: { data?: { content?: string; message?: string } };
    message?: string;
  };

  return (
    typedError?.response?.data?.content
    || typedError?.response?.data?.message
    || typedError?.message
    || fallback
  );
}
